module.exports = __webpack_public_path__ + "assets/img/statistics.521f0381.svg";